import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { setVariablesToCurrentPage } from '../../../../../../utils/reducers/reduxDispatch'
import { ComponentTabObject } from '../../../../../../utils/hooks/useTabLogic'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { getBasePath } from '../../../../../../utils/globals/link'
import EditCardTabs from '../../../../../../baseComponents/EditCardTabs'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { useParams } from 'react-router'
import { useLocation } from 'react-router'
import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import MainCreditorProfile from './Tabs/MainCreditorProfile'
import CreditorNotes from './Tabs/CreditorNotes'
import CreditorContactPersons from './Tabs/CreditorContactsPersons'
import CreditorServices from './Tabs/CreditorServices'
import CreditorTradeAgreements from './Tabs/CreditorTradeAgreements'
import CreditorFiles from './Tabs/CreditorFiles'
import CreditorBanks from './Tabs/CreditorBanks'
import CreditorBillingGroups from './Tabs/CreditorBillingGroups'


type SingleCreditorProps = SingleCreditorLogicProps & ComponentWithPermissions & {

}

const SingleCreditor: React.FC<SingleCreditorProps> = ({ userPermissions }) => {
    const location = useLocation()
    const params = useParams<{ id: string, tab?: string }>()
    const { t } = useTwinTranslation()
    const { basicData, getData } = useSingleCreditorLogic({ params })
    if (!params.id) {
        return null
    }
    const tabs: ComponentTabObject = {
        'main': { component: MainCreditorProfile, text: t('general', 'General'), permission: 'creditor.main' },
        'trade-agreements': { component: CreditorTradeAgreements, text: t('tradeAgreements', 'Acuerdos comerciales'), permission: 'creditor.tradeAgreements' },
        'contacts-persons': { component: CreditorContactPersons, text: t('people', 'Personas'), permission: 'creditor.contactPersons' },
        'bank': { component: CreditorBanks, text: t('bank', 'Banco'), permission: 'creditor.bank' },
        'service': { component: CreditorServices, text: t('services', 'Servicios'), permission: 'creditor.service'},
        'notes': { component: CreditorNotes, text: t('notes', 'Notas'), permission: 'creditor.main' },
        'billingGroups': { component: CreditorBillingGroups, text: t('billingGroups', 'Grupos de facturación'), permission: 'creditor.billingGroup' },
        'files': { component: CreditorFiles, text: t('files', 'Ficheros'), permission: 'creditor.files' },
    }

    return (<EditCardTabs basePath={getBasePath(location.pathname, params.id)} basicData={basicData} tabs={tabs} tab={params.tab} userPermissions={userPermissions} getData={getData} />)
}

interface SingleCreditorLogicProps {
    params: { id?: string, tab?: string }
}

const useSingleCreditorLogic = ({ params }: SingleCreditorLogicProps) => {
    const [basicData, setBasicData] = useState<SupplierModelType | null>(null)

    const id = params.id

    const getData = useCallback(async () => {
        const myData: SupplierModelType = await twinFetchPostJSON('/api/app/supplier/getSupplierInstance', {
            id
        })
        if (myData) {
            setBasicData(myData)
            setVariablesToCurrentPage([myData.name])
        }
    }, [setBasicData, id])

    useEffect(() => {
        getData()
    }, [getData])

    return { basicData, getData }
}

export default SingleCreditor